var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$attrs.show !== false)?_c('HyFLoader',{attrs:{"variant":_vm.relative ? 'overlay' : 'fullscreen'}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }